<mat-card *appHasRoles="['admin', 'manager', 'compliance']" class="content-card">
  <mat-card-header>
    <mat-card-title>
      <h5>Push Notification Logs</h5>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div class="list-item" fxLayout="row" fxLayoutGap="10px" >
      <label fxFlex="20" class="secondary">Date</label>
      <label fxFlex="15" class="secondary">Device</label>
      <label fxFlex="65" class="secondary">Content</label>

    </div>
    <div id="scroll">
      <ng-container *ngFor="let log of fcmSents">
        <ng-container *ngIf="log.title || log.body">
          <div class="list-item" fxLayout="row" fxLayoutGap="10px"  >

              <label class="" fxFlex="20" >{{ log.sendDate | date: "dd.MM.yyyy HH:mm" }}</label>
              <label class="" fxFlex="15" >{{ log.fcmToken }}</label>
              <label class="" fxFlex="65" >

                <div style="font-size: .8em; font-weight: bold">{{ log.title }}</div>
                <div style="font-size: .9em">{{ log.body }}</div>

              </label>

          </div>
        </ng-container>
      </ng-container>
    </div>
  </mat-card-content>
</mat-card>

